<rt-button
  class="summary"
  [class.summary--expanded]="expanded()"
  variant="plain"
  size="small"
  [attr.aria-expanded]="expanded()"
  (click)="toggle()"
>
  <rt-icon class="chev" name="expand-more" />
  <span>{{ count() }} step{{ count() === 1 ? '' : 's' }} completed</span>
</rt-button>

@if (expanded()) {
  <ul class="list">
    @for (step of steps(); track step.toolCallId) {
      <li [class.row--error]="step.status === 'error'" class="row">
        <span class="num">{{ $index + 1 }}.</span>
        <span class="name">{{ step.name }}</span>
        @if (step.status === 'error') {
          <rt-icon class="err" name="error" />
        }
      </li>
    }
  </ul>
}
